// extracted by mini-css-extract-plugin
export default {"RightArrowIcon":"Icons_RightArrowIcon__LYi+l"};